import React from 'react';
import styles from './index.module.scss';

type ProductTagProps = {
  text?: string;
  bgColor: string;
};
const ProductTag: React.FC<ProductTagProps> = ({ text, bgColor }) => {
  return (
    <div className={styles.tag} style={{ backgroundColor: bgColor }}>
      {text}
    </div>
  );
};
export default ProductTag;
